// extracted by mini-css-extract-plugin
export default {"container":"FormLabel_container__VKeIu","label":"FormLabel_label__C5hmO","breakLine":"FormLabel_breakLine__YswM5"};